export const Babeczki = [
  {
    "id": "mieszanka-1",
    "name": "Uniwersalna mieszanka mąk bezglutenowych",
    "category": "BABECZKI",
    "shortDesc": "Idealna do zastąpienia mąki pszennej w wypiekach",
    "fullDesc": "Idealna do wszelkich wypieków, ta mieszanka mąk bezglutenowych łączy w sobie neutralność mąki jaglanej, orzechowy posmak mąki gryczanej oraz zbożowy akcent mąki amarantusowej. Ważne są proporcje, które należy zachować, aby uzyskać właściwości mąk zawierających gluten. Świetnie sprawdza się jako zamiennik mąki pszennej, zachowując odpowiednią konsystencję i sprężystość w wypiekach.",
  
    "preparation": "Na 9 szklanek mieszanki \n(należy zachować proporcje pierwszych sześciu szklanek do pozostałych trzech szklanek mąki ziemniaczanej i tapioki):\n\n6 szklanek mąki (w dowolnej proporcji): jaglanej, gryczanej, z amarantusa (ewentualnie mąka ryżowa lub kukurydziana)\n2 szklanki mąki (w dowolnej proporcji) ziemniaczanej lub z tapioki\n\n\nPrzykład:\n3 szklanki mąki jaglanej\n2 szklanki mąki gryczanej\n1 szklanka mąki z amarantusa\n2 szklanki mąki ziemniaczanej\n1 szklanka mąki z tapioki\n\nLUB\n3 szklanki mąki jaglanej\n2 szklanki mąki gryczanej\n1 szklanka mąki z amarantusa\n3 szklanki mąki z tapioki\n\nLUB\n3 szklanki mąki jaglanej\n3 szklanki mąki gryczanej\n3 szklanki mąki z tapioki\n\nLUB\n3 szklanki mąki jaglanej\n3 szklanki mąki gryczanej\n3 szklanki mąki ziemniaczanej\n\nLUB najprościej\n6 szklanek mąki jaglanej\n3 szklanki mąki ziemniaczanej\n\nLUB moja ulubiona wersja\n1kg mąki jaglanej\n1kg mąki gryczanej\n1kg mąki z tapioki\n\n Wymieszać razem, najlepiej przesiewając stopniowo przez sito.\nUprzednie przesianie i wymieszanie mąk na sucho zapewnia lepszą strukturę ciasta, zapobiega grudkom i poprawia wyrastanie.\n\n\nZdrowego! 🌱✨💚",
    "ingredients": [
        "Proporcje są kluczowe – sprawdź opis przygotowania, aby poznać dokładne ilości:\n",
        "Mąka jaglana",
        "Opcjonalnie: mąka gryczana (i mąka z amarantusa)",
        "Ewentualnie: mąka ryżowa lub kukurydziana",
        "Mąki ziemniaczana",
        "Opcjonalnie: mąka z tapioki"
    ].join("\n"),
    "image": "Babeczki/mieszanka.jpg",
    "path": "babeczki"
},


  

  {
    id: 'babeczka-1',
    name: 'Kakaowe muffinki z soczewicy',
    category: 'BABECZKI',
    shortDesc: 'Zdrowe i szybkie',
    fullDesc: 'Te kakaowe babeczki to błyskawiczna przekąska, która zaskoczy Cię zarówno prostotą przygotowania, jak i smakiem. Wyglądają jak tradycyjny wypiek, więc niczego niespodziewający się smakosz mógłby się nawet dać nabrać, nie wiedząc, że zawierają soczewicę! Dzięki temu, że soczewica jest niemal niewyczuwalna, babeczki mają naturalnie słodki smak daktyli i banana. To świetny sposób, by przemycić zdrowe składniki, jak białko roślinne, w formie pysznej, słodkiej przekąski, którą pokochają zarówno dzieci, jak i dorośli.',
    image: 'Babeczki/babeczki_z_soczewicy.jpg',
  
    preparation: `
1. Przygotowanie soczewicy:\nPrzepłucz suchą soczewicę kilkakrotnie wodą.\nZalej świeżą wodą, dodaj szczyptę soli himalajskiej i gotuj na średnim ogniu do miękkości (około 8 minut).\nPo ugotowaniu odsącz ją na sitku i przelej zimną wodą, aby ostudzić.\n\n2. Rozgrzanie piekarnika:\nUstaw piekarnik na 180°C (termoobieg).\n\n3. Blendowanie składników:\nUmieść ugotowaną i ostudzoną soczewicę, jajka, daktyle, kakao, sodę oczyszczoną, sól i banana w dużej misce.\nZblenduj wszystko na gładką masę za pomocą blendera.\n\n4. Dodanie dodatków:\nDo masy dodaj posiekane migdały i żurawinę.\nWymieszaj dokładnie, aby składniki równomiernie rozprowadziły się w cieście.\n\n5. Przygotowanie foremek:\nPrzygotuj foremki na babeczki (papierowe lub silikonowe).\nPrzelej masę do foremek, wypełniając je po brzegi.\nOpcjonalnie posyp wierzch babeczek kaszą jaglaną ekspandowaną.\n\n6. Pieczenie:\nWstaw foremki do rozgrzanego piekarnika.\nPiecz przez około 35 minut, aż wyrosną z foremek. Aby sprawdzić, czy są gotowe, delikatnie dotknij je ręką w rękawicy – jeśli będą sprężyste, oznacza to, że są gotowe do wyjęcia z piekarnika.\n\n***Babeczki są naturalnie słodzone daktylami i bananem, ale możesz dostosować ilość ksylitolu do swojego smaku.\n\n\nZdrowego! 🌱✨💚
`,
    ingredients: [
      '⅔ szklanki suchej czerwonej soczewicy (lub 1 szklanka ugotowanej, z czubem)',
      '3 jajka',
      'Garść posiekanych suszonych daktyli (bez pestek)',
      '2 łyżki kakao',
      '½ łyżeczki sody oczyszczonej',
      'Szczypta soli himalajskiej lub innej wysokiej jakości',
      'Garść posiekanych migdałów',
      'Garść posiekanej żurawiny',
      'Opcjonalnie: 1 obrany banan',
      'Opcjonalnie: kasza jaglana ekspandowana lub wiórki kokosowe lub płatki migdałowe, do posypania',
      'Opcjonalnie: 2-4 łyżki ksylitolu***'
    ].join('\n'),
    path: 'babeczki'
},

{
  id: 'babeczka-2',
  name: 'Babeczki muffinki z cynamonem i jabłkami',
  category: 'BABECZKI',
  shortDesc: 'O smaku szarlotki',
  fullDesc: 'Te babeczki gryczane z cynamonem i jabłkami to zdrowa i pyszna alternatywa dla tradycyjnych wypieków. Mąka gryczana nadaje im lekko orzechowy posmak, a jabłka sprawiają, że są wilgotne i aromatyczne. Idealne na każdą porę dnia, szczególnie dla osób, które unikają glutenu.',
  image: 'Babeczki/babeczki_gryczane.jpg',
  preparation: `1. Rozgrzanie piekarnika:\nRozgrzej piekarnik do 180°C (termoobieg).\n\n2. Przygotowanie ciasta:\nDo miski przesiej mąkę gryczaną (lub mieszankę bezglutenową), sodę oczyszczoną, cynamon i ksylitol (jeśli używasz).\nDodaj jajka oraz jedno obrane jabłko. Zblenduj wszystkie składniki na gładką masę za pomocą blendera.\n\n3. Dodanie jabłka i bakalii:\nDrugie jabłko pokrój w małą kosteczkę.\nWmieszaj je delikatnie w ciasto. Następnie dodaj wybrane bakalie (goji, żurawinę lub aronię) i ponownie wymieszaj.\n\n4. Przygotowanie foremek:\nPrzygotuj foremki na muffinki lub babeczki, a następnie rozlej ciasto do foremek, wypełniając je po brzegi.\nPosyp wierzch babeczek odrobiną cynamonu.\n\n5. Pieczenie:\nWstaw babeczki do rozgrzanego piekarnika i piecz przez około 30 minut, aż wyrosną z foremek. Aby sprawdzić, czy są gotowe, delikatnie dotknij je ręką w rękawicy – jeśli będą sprężyste, oznacza to, że są gotowe do wyjęcia z piekarnika.\n\n\nZdrowego! 🌱✨💚
  `,
  ingredients: [
    '160 g mąki gryczanej + 3 łyżki mąki ziemniaczanej lub tapioki LUB 200 g uniwersalnej mieszanki mąk bezglutenowych {LINK}',
    '4 jajka',
    '2 jabłka, obrane i oczyszczone z gniazd nasiennych',
    '½ łyżeczki sody oczyszczonej (opcjonalnie)',
    '1 łyżeczka cynamonu do ciasta + do posypania',
    'Goja, żurawina lub aronia, według uznania',
    'Opcjonalnie: 6 łyżek ksylitolu'
  ].join('\n'),
  path: 'babeczki'
},



{
  "id": "babeczka-3",
  "name": "Super orzechowe babeczki bananowe",
  "category": "BABECZKI",
  "shortDesc": "Szybkie i smaczne babeczki",
  "fullDesc": "Te babeczki to jedne z moich ulubionych! Są nie tylko wyjątkowo smaczne, ale także niezwykle proste i szybkie w przygotowaniu. Połączenie dojrzałych bananów, mąki migdałowej i chrupiących orzechów sprawia, że babeczki są wilgotne, aromatyczne i pełne wartości odżywczych. Idealne jako zdrowa przekąska lub pożywne śniadanie – gotowe w zaledwie kilka chwil!",
  "image": "Babeczki/babeczki_orzechowe_bananowe.jpg",
  "preparation":`1. Rozgrzanie piekarnika:\nRozgrzej piekarnik do 175°C (termoobieg).\n\n2. Przygotowanie ciasta:\nBanany obierz ze skórki i rozgnieć widelcem w misce.\nDodaj mąkę migdałową, jajka, oliwę, sodę oczyszczoną oraz sól himalajską.\nWszystkie składniki wymieszaj mikserem do uzyskania jednolitej masy.\n\n3. Dodanie orzechów:\nPosiekane orzechy włoskie i laskowe delikatnie wmieszaj w ciasto.\n\n4. Przygotowanie foremek:\nPrzygotuj foremki na muffinki i rozlej do nich ciasto, wypełniając je po brzegi.\n\n5. Pieczenie:\nWstaw babeczki do rozgrzanego piekarnika i piecz przez około 30 minut, aż staną się złociste.\nBabeczki będą gotowe, gdy po nacśinięciu na wierzch będą stawiały lekki opór.\n\n***Najzdrowszą wersję mąki migdałowej można uzyskać, mieląc migdały w młynku do kawy.\n\n\nZdrowego! 🌱✨💚
  `,
  "ingredients": [
    "2 dojrzałe banany",
    "1 szklanka mąki migdałowej***",
    "2 jajka",
    "2 łyżki oliwy",
    "½ łyżeczki sody oczyszczonej",
    "¼ łyżeczki soli himalajskiej lub innej wysokiej jakości",
    "1–2 garście posiekanych orzechów włoskich",
    "1–2 garście posiekanych orzechów laskowych"
  ].join("\n"),
  "path": "babeczki"
}
,
{
  "id": "babeczka-4",
  "name": "Muffinki z jabłkiem, bananem, kawałkami czekolady i orzechami",
  "category": "BABECZKI",
  "shortDesc": "Tych babeczek wychodzi całkiem sporo",
  "fullDesc": "Te babeczki to idealna propozycja na dużą ilość pysznych, zdrowych przekąsek, które świetnie sprawdzą się na większych imprezach rodzinnych lub spotkaniach z przyjaciółmi. Połączenie banana, jabłka, orzechów, czekolady i mąki jaglanej tworzy wilgotne, aromatyczne babeczki, które mimo że są bogate, lekko się kruszą, co nadaje im wyjątkowej tekstury. Mąka jaglana jest niemal niewyczuwalna dzięki dodatkom, co sprawia, że babeczki są przyjemnie delikatne w smaku, a czekolada i orzechy dodają im chrupkości i głębi smaku. Doskonałe na duże spotkania, lub na długą trasę samochodem.",
  "image": "Babeczki/babeczka.jpg",
  "preparation": `1. Rozgrzanie piekarnika:\nRozgrzej piekarnik do 200°C (termoobieg).\n\n2. Przygotowanie ciasta:\nW dużej misce połącz wszystkie składniki, oprócz dwóch bananów, orzechów i czekolady. Zblenduj je dokładnie, aż uzyskasz jednolitą masę.\nDodaj pokrojonego w kostkę banana do ciasta i delikatnie wmieszaj.\nDodaj posiekane orzechy włoskie i kawałki gorzkiej czekolady, a następnie wymieszaj całość.\n\n3. Przygotowanie foremek:\nPrzygotuj foremki na muffinki i rozlej do nich ciasto, wypełniając je do pełna.\nNa wierzchu każdej babeczki umieść plasterki pozostałego banana oraz, jeśli chcesz, dodatkowe orzechy.\n\n4. Pieczenie:\nPiecz babeczki w piekarniku w temperaturze 200°C przez około 25 minut lub do momentu, aż wyrosną z foremek.\nAby sprawdzić, czy są gotowe, delikatnie dotknij je ręką w rękawicy – jeśli będą sprężyste, oznacza to, że są gotowe do wyjęcia z piekarnika.\nPo upieczeniu, wyjmij babeczki z piekarnika i odstaw je do ostudzenia.\n\n\nZdrowego! 🌱✨💚
`,
  "ingredients": [
    "3 banany obrane (2 do ciasta – jeden zblendowany z całością, drugi pokrojony w kostkę + 1 pokrojony w plasterki do dekoracji)",
    "1 jabłko (obrane i oczyszczone z gniazd nasiennych)",
    "2 szklanki mąki (np. jaglanej)",
    "½ szklanki ksylitolu",
    "1 szklanka mleka kokosowego",
    "2 jajka",
    "1 łyżeczka proszku do pieczenia bezglutenowego",
    "1 łyżeczka sody oczyszczonej",
    "Szczypta soli himalajskiej lub innej wysokiej jakości",
    "Opcjonalnie: garść posiekanych orzechów włoskich",
    "Opcjonalnie: garść posiekanej gorzkiej czekolady"
  ].join("\n"),
  "path": "babeczki"
}
,
{
  "id": "babeczka-5",
  "name": "Błyskawiczne muffinki murzynki z dżemem/powidłami",
  "category": "BABECZKI",
  "shortDesc": "Pieką się w 15 minut",
  "fullDesc": "Te błyskawiczne babeczki smakują jak tradycyjny polski murzynek, z delikatną wilgotnością dzięki dodaniu dżemu. Szybkie do przygotowania i piekące się zaledwie w 15 minut, a jeszcze szybciej znikają z talerza – idealne na każdą okazję. Proste składniki, łatwe przygotowanie, a efekt zawsze pyszny!",
  "image": "Babeczki/babeczka.jpg",
  "preparation": `1. Rozgrzanie piekarnika:\nRozgrzej piekarnik do 200°C (termoobieg).\n\n2. Przygotowanie ciasta:\nJajka ubij ze szczyptą soli himalajskiej mikserem na puszystą masę.\nStrużką wlewaj miód, wciąż ubijając.\nDodaj mąkę, sodę i kakao. Wszystko dokładnie wymieszaj mikserem.\nStrużką wlej olej, ciągle ubijając ciasto mikserem.\nDodaj dżem lub powidła i jeszcze raz wymieszaj.\n\n3. Pieczenie:\nRozlej ciasto do foremek na babeczki i piecz przez 15 minut w termoobiegu, aż wyrosną z foremek./nAby sprawdzić, czy są gotowe, delikatnie dotknij je ręką w rękawicy – jeśli będą sprężyste, oznacza to, że są gotowe do wyjęcia z piekarnika.\n\n4. Po upieczeniu:\nPo wystudzeniu posyp babeczki cukrem pudrem.\n\n\nZdrowego! 🌱✨💚
`,
  "ingredients": [
    "3 jajka",
    "Szczypta soli himalajskiej lub innej wysokiej jakości",
    "½ szklanki miodu",
    "1 szklanka uniwersalnej mieszanki mąk bezglutenowych {LINK}",
    "½ łyżeczki sody oczyszczonej",
    "2 łyżki kakao",
    "⅓ szklanki oleju",
    "4-5 łyżek dżemu lub powideł"
  ].join("\n"),
  "path": "babeczki"
}
,


{
  "id": "babeczka-6",
  "name": "Muffinki makowe",
  "category": "BABECZKI",
  "shortDesc": "Ukochane przez moje dzieci",
  "fullDesc": "Te muffinki makowe to idealna propozycja na zdrową przekąskę lub deser. Połączenie mąki jaglanej, kukurydzianej i tapioki sprawia, że są lekkie i bezglutenowe, a mak dodaje im intensywnego smaku i wartości odżywczych. Zamiast tradycyjnych jajek, można użyć nasion lnu, co czyni je bardziej przyjaznymi dla wegan. Dzięki mleku kokosowemu muffinki mają delikatny aromat, a dodatek migdałów wprowadza przyjemną chrupkość. Idealne na każdą okazję!",
  "image": "Babeczki/babeczki_makowe.jpg",
  "preparation": `1. Rozgrzanie piekarnika:\nRozgrzej piekarnik do 180°C (termoobieg).\n\n2. Przygotowanie ciasta:\nW misce połącz wszystkie składniki, oprócz migdałów (i tych do posypania muffinek). Zblenduj je blenderem na jednolitą masę.\nDodaj migdały (jeśli używasz) i wymieszaj ręcznie.\n\n3. Pieczenie:\nPrzełóż ciasto do foremek na muffinki.\nPosyp muffinki makiem i odrobiną cukru trzcinowego.Piecz przez około 40 minut w 160°C, aż muffinki wyrosną z foremek. Aby sprawdzić, czy są gotowe, delikatnie dotknij je ręką w rękawicy – jeśli będą sprężyste, oznacza to, że są gotowe do wyjęcia z piekarnika.\n\n4. Po upieczeniu:\nPodawaj po wystudzeniu.\n\n\nZdrowego! 🌱✨💚
`,
  "ingredients": [
    "1 dojrzały banan",
    "2 jajka",
    "5 łyżek maku niebieskiego + do posypania muffinek",
    "250g uniwersalnej mieszanki mąk bezglutenowych {LINK}",
    "½  łyżeczki proszku do pieczenia bezglutenowego",
    "½  łyżeczka sody oczyszczonej",
    "½ szklanki oleju rzepakowego",
    "½ szklanki mleka kokosowego",
    "5 łyżeczek ksylitolu",
    "Szczypta soli himalajskiej lub innej wysokiej jakości",
    "Opcjonalnie: 3 łyżki migdałów, posiekanych lub całości",
    "Opcjonalnie: trochę cukru trzcinowego do posypania muffinek",
  ].join("\n"),
  "path": "babeczki"
}
,

{
  "id": "babeczka-7",
  "name": "Kokosowe babeczki z ciecierzycy",
  "category": "BABECZKI",
  "shortDesc": "Ciecierzycy nie czuć w smaku",
  "fullDesc": "Kokosowe babeczki z ciecierzycy to pyszne, zdrowe i bezglutenowe babeczki, które zaskakują wyjątkowym smakiem i teksturą. Ciecierzyca nadaje im wilgotności, a kokos w postaci wiórków wprowadza naturalny smak. Dzięki ksylitolowi, babeczki mają delikatną słodycz, a dodatek słonecznika i żurawiny wprowadza chrupkość oraz owocowy akcent. To świetna opcja na zdrową przekąskę, idealna do kawy czy herbaty!",
  "image": "Babeczki/babeczka.jpg",
  "preparation": `1. Przygotowanie ciecierzycy:\nCiecierzycę najlepiej i najzdrowiej namoczyć w wodzie przez noc (możesz od razu namoczyć i ugotować więcej, żeby później przygotować też hummus (pasta z ciecierzycy) {LINK}). Po czym ugotuj ją w świeżej wodzie do miękkości. Jeśli nie masz czasu na namoczenie, ugotuj ciecierzycę z łyżeczką sody oczyszczonej, co przyspieszy proces.\nPo ugotowaniu odsącz ją na sitku i przelej zimną wodą, aby przestygła.\n2. Rozgrzanie piekarnika:\nRozgrzej piekarnik do 180°C.\n3. Przygotowanie ciasta:\nW dużej misce połącz wszystkie składniki, oprócz słonecznika i żurawiny. Zblenduj je (blenderem ręcznym ze stopą) na gładką masę.\nDodaj słonecznik i żurawinę, delikatnie wymieszaj je w cieście.\n4. Pieczenie:\nPrzełóż ciasto do foremek na babeczki.\nOpcjonalnie, posyp wierzch babeczek wiórkami kokosowymi przed pieczeniem.\nPiecz przez około 35 minut, aż muffinki wyrosną z foremek. Aby sprawdzić, czy są gotowe, delikatnie dotknij je ręką w rękawicy – jeśli będą sprężyste, oznacza to, że są gotowe.\n5. Po upieczeniu:\nPodawaj po wystudzeniu.\n\n\nZdrowego! 🌱✨💚
`,
  "ingredients": [
    "1 niepełna szklanka ugotowanej ciecierzycy lub około pół szklanki suchej + 1 łyżeczka sody oczyszczonej",
    "3 jajka",
    "3 łyżki ksylitolu",
    "3 łyżki wiórków kokosowych",
    "½ łyżeczki sody",
    "Szczypta soli himalajskiej lub innej wysokiej jakości",
    "Garść słonecznika łuskanego",
    "Garść posiekanej żurawiny",
    "Opcjonalnie: wiórki kokosowe do posypania"
  ].join("\n"),
  "path": "babeczki"
}

,

{
  "id": "babeczka-8",
  "name": "Kakaowe babeczki fasolowe",
  "category": "BABECZKI",
  "shortDesc": "W smaku nie czuć fasoli",
  "fullDesc": "Kakaowe babeczki fasolowe to pyszna, zdrowa alternatywa dla tradycyjnych babeczek. Czerwone fasole dodają im wilgotności i wartości odżywczych, a kakao i ksylitol nadają im intensywny, czekoladowy smak. Dzięki migdałom i rodzynkom, babeczki zyskują dodatkową chrupkość i słodycz. Są idealne na każdą okazję, na przykład na zdrową przekąskę do kawy czy jako deser na podwieczorek.",
  "image": "Babeczki/babeczki_fasolowe.jpg",
  "preparation": `1. Rozgrzanie piekarnika:\nRozgrzej piekarnik do 180°C (termoobieg).\n\n2. Przygotowanie ciasta:\nW dużej misce połącz wszystkie składniki, oprócz migdałów i rodzynek.\nZblenduj je blenderem na gładką masę.\nDodaj migdały i rodzynki, a następnie delikatnie wymieszaj je w cieście.\n\n3. Pieczenie:\nWlej ciasto do foremek na babeczki.\nPosyp wierzch płatkami migdałowymi (jeśli chcesz).\nPiecz przez około 35 minut, aż babeczki staną się złociste i sprężyste.\n\n4. Po upieczeniu:\nPo wystudzeniu, podawaj i ciesz się smakiem!\n\n\nZdrowego! 🌱✨💚
`,
  "ingredients": [
    "1 szklanka ugotowanej czerwonej fasoli",
    "Opcjonalnie: 1 banan, obrany",
    "3 jajka",
    "2 łyżki kakao",
    "3 łyżki ksylitolu",
    "½ łyżeczki sody oczyszczonej",
    "½ łyżeczki proszku do pieczenia bezglutenowego",
    "Szczypta soli himalajskiej lub innej wysokiej jakości",
    "Garść posiekanych migdałów",
    "Garść rodzynek",
    "Opcjonalnie: płatki migdałowe do dekoracji"
  ].join("\n"),
  "path": "babeczki"
}
,

{
  "id": "babeczka-9",
  "name": "Muffinki amarantusowe",
  "category": "BABECZKI",
  "shortDesc": "Puchowe babeczki",
  "fullDesc": "Muffinki amarantusowe to pyszne, zdrowe babeczki, które zaskoczą Cię lekką konsystencją i nutą naturalnej słodyczy. Amarantus ekspandowany nadaje im delikatności, a orzechy włoskie i rodzynki dodają chrupkości i słodyczy. Idealne na zdrowe śniadanie, podwieczorek lub przekąskę. Można je wzbogacić o różne dodatki, takie jak suszone owoce, wiórki kokosowe czy migdały, w zależności od gustu.",
  "image": "Babeczki/babeczka.jpg",
  "preparation": `1. Rozgrzanie piekarnika:\nRozgrzej piekarnik do 180°C.\n\n2. Przygotowanie mikstury:\nMikserem ubij jajka z ksylitolem, solą i sodą, aż masa stanie się puszysta.\nDodaj amarantus, rodzynki i posiekane orzechy. Wszystko dokładnie wymieszaj mikserem.\n\n3. Pieczenie:\nPrzełóż ciasto do foremek na muffinki.\nPiecz przez około 35 minut,  aż muffinki wyrosną z foremek. Aby sprawdzić, czy są gotowe, delikatnie dotknij je ręką w rękawicy – jeśli będą sprężyste, oznacza to, że są gotowe do wyjęcia z piekarnika.\n\n4. Po upieczeniu:\nPo wystudzeniu, podawaj i ciesz się smakiem!\n\nDodatkowe wskazówki:\nMożesz dodać inne suszone owoce, np. żurawinę, lub posiekane orzechy, płatki migdałowe, wiórki kokosowe, kakao, cynamon, słonecznik, sezam.\nCzęść amarantusa ekspandowanego można zastąpić komosą ryżową ekspandowaną, np. używając 2,5 szklanki amarantusa i 0,5 szklanki komosy.\n\n\nZdrowego! 🌱✨💚
`,
  "ingredients": [
    "3 szklanki amarantusa ekspandowanego",
    "3 jajka",
    "3 łyżki ksylitolu",
    "Opcjonalnie: ½ łyżeczki sody spożywczej",
    "Szczypta soli himalajskiej lub innej wysokiej jakości",
    "Garść rodzynek",
    "Opcjonalnie: garść posiekanych orzechów włoskich"
  ].join("\n"),
  "path": "babeczki"
},

{
  "id": "babeczka-10",
  "name": "Babeczki biszkoptowe z owocami",
  "category": "BABECZKI",
  "shortDesc": "Lekka, puszysta alternatywa",
  "fullDesc": "Babeczki biszkoptowe z owocami to lekka, puszysta alternatywa na słodką przekąskę. Ich smak wzbogacają świeże lub mrożone owoce, a opcjonalny dżem nadaje im wyjątkowego, owocowego aromatu. Dzięki mące bezglutenowej, babeczki są idealne dla osób na diecie bezglutenowej, a ksylitol sprawia, że są zdrową alternatywą dla tradycyjnych słodkości. Pyszne, lekkie i pełne smaku – doskonałe na każdą okazję!",
  "image": "Babeczki/babeczka.jpg",
  "preparation": `1. Rozgrzanie piekarnika:\nRozgrzej piekarnik do 180°C.\n\n2. Przygotowanie ciasta:\nŻółtka oddziel od białek\nBiałka ubij na sztywną pianę ze szczyptą soli himalajskiej, a następnie dodaj ksylitol, ciągle miksując.\nMąkę z sodą oczyszczoną przesiej przez sito i wymieszaj razem.\nDodaj mąkę z sodą, żółtka i olej. Delikatnie wymieszaj wszystkie składniki, aby uzyskać jednolite ciasto.\n\n3. Przygotowanie foremek:\nWlej ciasto do foremek na babeczki. Możesz udekorować wierzch owocami lub w połowie nakładania ciasta nałożyć odrobinę dżemu i przykryć ciastem.\n\n4. Pieczenie:\nPiecz przez około 30 minut w termoobiegu, aż aż muffinki wyrosną z foremek. Aby sprawdzić, czy są gotowe, delikatnie dotknij je ręką w rękawicy – jeśli będą sprężyste, oznacza to, że są gotowe do wyjęcia z piekarnika.\n\n5. Po upieczeniu:\nPo wystudzeniu, podawaj i ciesz się pysznymi, biszkoptowymi babeczkami!\n\n\nZdrowego! 🌱✨💚
`,
  "ingredients": [
    "4 jajka",
    "Około 120g uniwersalnej mieszanki mąk bezglutenowych {LINK}",
    "Szczypta soli himalajskiej lub innej wysokiej jakości",
    "4 łyżki ksylitolu",
    "2 łyżki oleju",
    "¼ łyżeczki sody oczyszczonej",
    "Opcjonalnie: jagody (mrożone) lub inne owoce, np. maliny, borówki, jeżyny, lub dżem"
  ].join("\n"),
  "path": "babeczki"
}
,
{
  "id": "babeczka-11",
  "name": "Muffinki marchewkowe",
  "category": "BABECZKI",
  "shortDesc": "Mini ciasta marchewkowe",
  "fullDesc": "Muffinki marchewkowe to pyszna, zdrowa przekąska pełna smaku i wartości odżywczych. Dzięki marchewce i dyni (lub musowi jabłkowemu), są wilgotne i pełne naturalnej słodyczy. Mąki jaglanej, gryczanej, ziemniaczanej i tapioki zapewniają im odpowiednią teksturę, a cynamon i orzechy włoskie dodają aromatycznego smaku. Te muffinki to doskonały wybór na śniadanie, podwieczorek lub zdrową przekąskę!",
  "image": "Babeczki/babeczka.jpg",
  "preparation": `1. Rozgrzanie piekarnika:\nRozgrzej piekarnik do 180°C.\n\n2. Przygotowanie ciasta:\nOlej kokosowy rozpuść (włóż słoik do ciepłej wody, aby stał się płynny).\nBiałka ubij na sztywno, w osobnej misce połącz resztę składników (w tym żółtka) i wymieszaj mikserem.\nDodaj ubite białka do ciasta i delikatnie wymieszaj.\nDodaj orzechy i wymieszaj ciasto łyżką.\n\n3. Przygotowanie foremek:\nPrzelej ciasto do foremek na muffinki.\n\n4. Pieczenie:\nPiecz przez około 40 minut, aż muffinki wyrosną z foremek.\nAby sprawdzić, czy są gotowe, delikatnie dotknij je ręką w rękawicy – jeśli będą sprężyste, oznacza to, że są gotowe do wyjęcia z piekarnika.\n\n5. Po upieczeniu:\nPo upieczeniu, wystudź muffinki i podawaj.\n\n\nZdrowego! 🌱✨💚
`,
  "ingredients": [
    "2 średnie marchewki starte na tarce o drobnych oczkach",
    "½ szklanki pieczonej dyni lub musu jabłkowego",
    "200g uniwersalnej mieszanki mąk bezglutenowych {LINK}",
    "3 jajka",
    "½ szklanki miodu",
    "½ szklanki płynnego oleju kokosowego",
    "1 łyżeczka sody oczyszczonej",
    "1 łyżeczka cynamonu",
    "Szczypta soli himalajskiej lub innej wysokiej jakości",
    "Garść posiekanych orzechów włoskich lub pekan"
  ].join("\n"),
  "path": "babeczki"
}
,
{
  "id": "babeczka-12",
  "name": "Bananowe muffinki karobowe",
  "category": "BABECZKI",
  "shortDesc": "Przepyszna i zdrowa alternatywa",
  "fullDesc": "Bananowe muffinki kakaowe to przepyszna i zdrowa alternatywa dla tradycyjnych babeczek. Dzięki dojrzałym bananom, są naturalnie słodkie, a karob (lub kakao) wprowadza czekoladowy smak. Mąka bezglutenowa sprawia, że muffinki są odpowiednie dla osób na diecie bezglutenowej. Olej kokosowy nadaje im wilgotności, a wanilia wzbogaca smak. Idealne na podwieczorek, śniadanie lub jako zdrowa przekąska!",
  "image": "Babeczki/babeczka.jpg",
  "preparation": `1. Rozgrzanie piekarnika:\nRozgrzej piekarnik do 180°C.\n\n2. Przygotowanie ciasta:\nW misce połącz wszystkie składniki i zmiksuj je przy pomocy blendera, aż uzyskasz jednolitą masę.\n\n3. Przygotowanie foremek:\nPrzełóż ciasto do foremek na muffinki.\n\n4. Pieczenie:\nPiecz przez około 40 minut w piekarniku (opcja grzanie dół), aż muffinki wyrosną z foremek.\nAby sprawdzić, czy są gotowe, delikatnie dotknij je ręką w rękawicy – jeśli będą sprężyste, oznacza to, że są gotowe do wyjęcia z piekarnika.\n\n5. Po upieczeniu:\nPo upieczeniu, wystudź muffinki i podawaj.\n\n\nZdrowego! 🌱✨💚
`,
  "ingredients": [
    "1 kopiasta szklanka uniwersalnej mieszanki mąk bezglutenowych {LINK}",
    "½ szklanka karobu (można zastąpić kakao)",
    "2 duże dojrzałe banany",
    "2 duże jajka",
    "½ szklanki cukru kokosowego lub ksylitolu",
    "½ szklanki rozpuszczonego oleju kokosowego",
    "½ łyżeczki proszku do pieczenia bezglutenowego",
    "½ łyżeczki sody oczyszczonej",
    "Szczypta soli himalajskiej lub innej wysokiej jakości"
  ].join("\n"),
  "path": "babeczki"
}
,
{
  "id": "babeczka-13",
  "name": "Muffinki na majonezie / Zeberki / Straciatella",
  "category": "BABECZKI",
  "shortDesc": "Smak majonezu jest niewyczuwalny",
  "fullDesc": "Te muffinki na majonezie to wyjątkowo wilgotne, delikatne i puszyste babeczki, które zaskoczą Cię nietypowym składnikiem – majonezem! Dzięki niemu babeczki zyskują lekką konsystencję i wyjątkową wilgotność. Ksylitol nadaje im delikatną słodycz, a mąka bezglutenowa sprawia, że są odpowiednie dla osób na diecie bezglutenowej. Z dodatkiem kakao, mogą stać się dwukolorowe – idealne na każdą okazję!",
  "image": "Babeczki/babeczka.jpg",
  "preparation": `1. Rozgrzanie piekarnika:\nRozgrzej piekarnik do 190°C.\n\n2. Przygotowanie ciasta:\nJajka ubij z ksylitolem na puszysty krem.\nStopniowo dodawaj mąkę bezglutenową, mąkę ziemniaczaną, majonez i proszek do pieczenia. Wymieszaj całość za pomocą miksera, aż składniki się dobrze połączą.\n\n3. Przygotowanie foremek:\nPrzelej ciasto do foremek na muffinki.\n\nOpcjonalne warianty:\nJeśli chcesz uzyskać muffinki dwukolorowe, możesz zostawić kilka łyżek ciasta, dodać do nich kakao i nałożyć na wierzch.\nJeśli chcesz uzyskać zeberki to zostaw połowę surowego ciasta, dodaj do niego 1 łyżkę kakao, do pozostałej połowy dodaj 1 łyżkę mąki bezglutenowej domowej mieszanki. Po czym wlewaj naprzemiennie po łyżce masy ciemnej i masy jasnej.\nJeśli chcesz uzyskać muffinki straciatella, to poszatkuj drobno gorzką czekoladę i wmieszaj w ciasto.\n\n4. Pieczenie:\nPiecz przez około 30-35 minut, aż muffinki będą złociste i sprężyste.\n\n5. Po upieczeniu:\nPo upieczeniu, wystudź muffinki i podawaj. Wyglądają bajecznie posypane cukrem pudrem.\n\n\nZdrowego! 🌱✨💚
`,
  "ingredients": [
    "4 jajka",
    "⅔ szklanki ksylitolu",
    "½ szklanki uniwersalnej mieszanki mąk bezglutenowych {LINK}",
    "½ szklanki mąki ziemniaczanej",
    "2 łyżeczki proszku do pieczenia bezglutenowego",
    "5 łyżek domowego majonezu {LINK}",
    "Szczypta soli himalajskiej lub innej wysokiej jakości",
    "Opcjonalnie: kakao lub pół tabliczki gorzkiej czekolady"
  ].join("\n"),
  "path": "babeczki"
}
,
{
  "id": "babeczka-14",
  "name": "Babeczki bananowe z borówkami na mące kokosowej",
  "category": "BABECZKI",
  "shortDesc": "Idealne też na dietę paleo",
  "fullDesc": "Babeczki bananowe z borówkami na mące kokosowej to pyszna, zdrowa alternatywa na słodką przekąskę, która spełnia wymagania diety paleo i bezglutenowej. Dzięki dojrzałym bananom babeczki są naturalnie słodkie, a mąka kokosowa nadaje im delikatną teksturę. Borówki w środku i na wierzchu wprowadzają świeży owocowy smak, a całość jest idealna na zdrowe śniadanie lub podwieczorek!",
  "image": "Babeczki/babeczka.jpg",
  "preparation": `1. Rozgrzanie piekarnika:\nPiekarnik nagrzej do 170°C (termoobieg).\n\n2. Przygotowanie ciasta:\nKawałki bananów wrzuć do miski i zmiksuj ręcznym blenderem, aż powstanie gładka, napowietrzona masa.\nNastępnie wbij jajka i cały czas miksując, dodaj ksylitol, olej kokosowy i sok z cytryny.\nŁyżka po łyżce dodaj skrobię i mąkę kokosową. Uważnie obserwuj konsystencję – mąka kokosowa pęcznieje, dlatego najlepiej odczekać chwilę po dodaniu każdej łyżki. Ciasto powinno być bardziej leiste niż kleiste, ale nie za gęste.\nNa koniec dodaj sodę oczyszczoną i jeszcze raz przemieszaj.\n\n3. Przygotowanie foremek:\nPrzygotuj foremki na babeczki, nałóż część ciasta, ułóż trochę borówek, a następnie zalej resztą ciasta. Wierzch możemy również posypać borówkami.\n\n4. Pieczenie:\nFormę wstaw do piekarnika nagrzanego do 170°C i piecz przez 30-40 minut, aż muffinki wyrosną z foremek. Aby sprawdzić, czy są gotowe, delikatnie dotknij je ręką w rękawicy – jeśli będą sprężyste, oznacza to, że są gotowe do wyjęcia z piekarnika.\n\n5. Po upieczeniu:\nPo upieczeniu, gotowe babeczki można posmarować roztopioną pastą kokosową i posypać dodatkowymi borówkami.\n\n\nZdrowego! 🌱✨💚
`,
  "ingredients": [
    "5 jaj",
    "2 banany, obrane",
    "1 łyżka ksylitolu",
    "1 łyżka oleju kokosowego",
    "3 łyżeczki soku z cytryny",
    "3-4 łyżki mąki kokosowej",
    "1 i ½ łyżki skrobi z tapioki (może być ziemniaczana)",
    "½ łyżeczki sody oczyszczonej",
    "200 g borówek + dodatkowo do posypania i dekoracji",
    "Opcjonalnie: pasta kokosowa"
  ].join("\n"),
  "path": "babeczki"
},
{
  "id": "babeczka-15",
  "name": "Muffinki jogurtowe wege",
  "category": "BABECZKI",
  "shortDesc": "Tzw. kubeczkowe",
  "fullDesc": "Gâteau au Yaourt, znane we francuskich domach, jest prawdopodobnie tak popularne jak w naszych szarlotka. To pierwsze ciasto, które francuskie dzieci przygotowują samodzielnie. Ten przepis jest zaadaptowaną wersją dla potrzeb diety eliminacyjnej, co sprawia, że jest to doskonała opcja dla osób na diecie bezglutenowej. Babeczki jogurtowe są lekkie, wilgotne, delikatne i pełne smaku, idealne na każdą okazję!",
  "image": "Babeczki/babeczki_jogurtowe.jpg",
  "preparation": `1. Przygotowanie ciasta:\nPrzełóż jogurt do miseczki. Umyj i wysusz kubeczek po jogurcie i użyj go do odmierzania pozostałych składników.\nZmieszaj mąkę z proszkiem do pieczenia, a następnie dodaj resztę składników. Wymieszaj wszystko bardzp pobieznie do połączenia składników.\n\n2. Przygotowanie foremek:\nPrzelej ciasto do foremek na muffinki. Możesz do połowy ciasta dodać 2 łyżki kakao, żeby uzyskać babeczki dwukolorowe. Nakładaj wtedy ciasto naprzemiennie.\n\n3. Pieczenie:\nPiecz w piekarniku nagrzanym do 180°C przez 25 do 30 minut, aż ciasto stanie się złociste.\n\n4. Po upieczeniu:\nPo wystudzeniu, posyp babeczki cukrem pudrem.\n\nWskazówka:\nCiasto należy tylko pobieżnie wymieszać, nie wolno go wyrabiać, miksować ani ubijać.\n\n\nZdrowego! 🌱✨💚
`,
  "ingredients": [
    "Tutaj składniki odmierzamy kubeczkiem po jogurcie – sprawdź opis przygotowania.",
    "1 kubeczek jogurtu wegańskiego (do 200 g)",
    "3 kubeczki uniwersalnej mieszanki mąk bezglutenowych {LINK}",
    "1 niepełny kubeczek ksylitolu",
    "1 i ½ łyżeczki proszku do pieczenia bezglutenowego",
    "3 jaja",
    "1 kubeczek oleju roślinnego",
    "Cukier puder do posypania po wierzchu",
    "Opcjonalnie: 2 łyżki kakao",
  ].join("\n"),
  "path": "babeczki"
},

{
  "id": "babeczka-16",
  "name": "Muffinki owsiane",
  "category": "BABECZKI",
  "shortDesc": "Idealne na zdrową przekąskę",
  "fullDesc": "Te pyszne i zdrowe muffinki owsiane, autorstwa Ewy Chodakowskiej, to doskonała alternatywa dla tradycyjnych słodkości. Zawierają naturalne składniki, takie jak banan, jabłko, płatki owsiane, jogurt kozi lub wegetariański oraz orzechy, dzięki czemu są pełne błonnika, witamin i minerałów. Idealne na śniadanie, podwieczorek lub zdrową przekąskę. Dodatkowo, są łatwe i szybkie do przygotowania. Można je także wzbogacić o miód, aby nadać im jeszcze większej słodyczy. Polecam również przepis na Alternatywne Muffinki Owsiane bez jogurtu [LINK].",
  "image": "Babeczki/babeczka.jpg",
  "preparation": `
1. Przygotowanie składników:\nBanana obierz ze skórki, umieść w misce i rozgnieć widelcem.\nJabłko umyj, obierz ze skórki, usuń gniazdo nasienne i zetrzyj na tarce o grubych oczkach. Dodaj do banana.\nDodaj resztę składników: płatki owsiane, jajko, jogurt, proszek do pieczenia, cynamon, olej kokosowy, rodzynki, migdały oraz opcjonalnie miód.\nWszystko dobrze wymieszaj razem, aż składniki się połączą.\n\n2. Przygotowanie foremek:\nPrzełóż ciasto do foremek na muffinki.\n\n3. Pieczenie:\nPiecz przez 30 minut w piekarniku nagrzanym do 180°C.\n\n4. Po upieczeniu:\nPo wystudzeniu, podawaj.\n\n\nZdrowego! 🌱✨💚
`,
  "ingredients": [
    "1 banan",
    "½ jabłka",
    "6-7 łyżek płatków owsianych",
    "1 jajko",
    "½ szklanki jogurtu koziego lub wege",
    "½ łyżeczki proszku do pieczenia bezglutenowego",
    "½ łyżeczki cynamonu",
    "Płaska łyżka rozpuszczonego oleju kokosowego",
    "Garść rodzynek",
    "Dwie garście poszatkowanych migdałów",
    "Opcjonalnie: 1-2 łyżki miodu"
  ].join("\n"),
  "path": "babeczki"
},
{
  "id": "babeczka-17",
  "name": "Alternatywne muffinki owsiane bez jogurtu",
  "category": "BABECZKI",
  "shortDesc": "Poprostu pyszne",
  "fullDesc": "Te babeczki owsiane to pyszna i zdrowa alternatywa dla tradycyjnych słodkości, idealna na śniadanie, podwieczorek lub zdrową przekąskę. Dzięki użyciu płatków owsianych i bakalii, są pełne błonnika, witamin i minerałów. Banan i jabłko nadają im naturalnej słodyczy, a dodatki takie jak orzechy, rodzynki i chia sprawiają, że każda babeczka jest pełna smaku i wartości odżywczych. Proste w przygotowaniu, a do tego pyszne i zdrowe!",
  "image": "Babeczki/babeczka.jpg",
  "preparation": `1. Przygotowanie składników:\nWszystkie składniki, oprócz bakalii, zblenduj na gładką masę.\nDodaj bakalie i delikatnie wymieszaj.\n\n2. Przygotowanie foremek:\nPrzełóż ciasto do foremek na babeczki.\n\n3. Pieczenie:\nPiecz w piekarniku nagrzanym do 180°C (góra-dół) przez około 35 minut, aż babeczki będą złociste i sprężyste.\n\n4. Po upieczeniu:\nPo wystudzeniu, podawaj i ciesz się smakiem!\n\n\nZdrowego! 🌱✨💚
`,
  "ingredients": [
    "1 banan",
    "1 jabłko",
    "10 łyżek płatków owsianych bezglutenowych",
    "2 jajka",
    "2 łyżki rozpuszczonego oleju kokosowego",
    "½ łyżeczki sody oczyszczonej",
    "½ łyżeczki cynamonu",
    "2 łyżki ksylitolu",
    "4 łyżki bakalii (mieszanka poszatkowanych orzechów, rodzynek, żurawiny, goji, sezamu, chia itp.)"
  ].join("\n"),
  "path": "babeczki"
},

{
  "id": "babeczka-18",
  "name": "Muffinki daktylowe brownie",
  "category": "BABECZKI",
  "shortDesc": "Czekoladowa rozkosz",
  "fullDesc": "Daktylowe brownie to pyszna alternatywa dla tradycyjnych słodkości, idealna dla osób na diecie bezglutenowej. Dzięki daktylom, masłu orzechowemu i kakao, brownie jest pełne naturalnej słodyczy i bogatego smaku. Siemię lniane, ocet balsamiczny i soda oczyszczona sprawiają, że masa jest odpowiednio wilgotna i puszysta. Idealne na zdrowy deser lub przekąskę!",
  "image": "Babeczki/babeczka.jpg",
  "preparation": `1. Rozgrzanie piekarnika:\nRozgrzej piekarnik do 180°C.\n\n2. Przygotowanie ciasta:\nW blenderze zblenduj daktyle i wodę na gładki krem (może przybrać formę kulki, ale to w porządku).\nDodaj masło orzechowe, siemię lniane, kakao, sodę oczyszczoną, ocet i sól. Blenduj aż uzyskasz gęstą i klejącą masę.\n\n3. Przygotowanie foremek:\nPrzełóż masę do foremek (najlepiej użyć łyżki do lodów) i spłaszcz masę w foremkach mokrymi palcami.\n\n4. Pieczenie:\nPiecz przez 12-15 minut, aż wierzch babeczek stanie się sprężysty.\nBabeczki staną się twardsze, gdy ostygną.\n\n5. Po upieczeniu:\nPo wystudzeniu, podawaj.\n\n\nZdrowego! 🌱✨💚
`,
  "ingredients": [
    "¾ szklanki daktyli",
    "½ szklanki wody",
    "½ szklanki masła orzechowego z nerkowców (lub innego masła orzechowego)",
    "1 łyżka złotego siemienia mielonego",
    "5 łyżek kakao",
    "½ łyżeczki sody oczyszczonej",
    "2 łyżeczki octu balsamicznego",
    "Szczypta soli himalajskiej lub innej wysokiej jakości"
  ].join("\n"),
  "path": "babeczki"
},

{
  "id": "babeczka-19",
  "name": "Muffinki bananowo kokosowo orzechowe",
  "category": "BABECZKI",
  "shortDesc": "Aromatyczne",
  "fullDesc": "Muffinki bananowe z orzechami to zdrowa i pyszna alternatywa na lekkie śniadanie lub przekąskę. Dzięki dojrzałym bananom, orzechowemu maśle migdałowemu i kokosowej mące, te muffinki są naturalnie słodkie i pełne zdrowych tłuszczy. Przyprawy takie jak cynamon i gałka muszkatołowa nadają im wyjątkowego aromatu, a kokosowy olej sprawia, że są wilgotne i smaczne. To świetna opcja na zdrową przekąskę, którą można zabrać ze sobą wszędzie.",
  "image": "Babeczki/babeczka.jpg",
  "preparation": `1. Rozgrzanie piekarnika:\nRozgrzej piekarnik do 175°C. Włóż papilotki do formy na muffinki.\n\n2. Przygotowanie ciasta:\nW dużej misce połącz rozgniecione banany, jajka, masło migdałowe, olej kokosowy. Użyj blendera ręcznego, aby dobrze połączyć składniki.\nDodaj mąkę kokosową, cynamon, gałkę muszkatołową, proszek do pieczenia, sodę oczyszczoną i sól. Mieszaj, aż składniki się połączą, a masa stanie się jednolita.\n\n3. Pieczenie:\nPrzełóż ciasto do foremek na muffinki, wypełniając je do 2/3 wysokości.\nPiecz przez 20-25 minut, aż wykałaczka wbita w ciasto wyjdzie czysta.\n\n4. Po upieczeniu:\nPodawaj ciepłe lub przechowuj w lodówce w szczelnie zamkniętej torbie.\n\n\nZdrowego! 🌱✨💚
`,
  "ingredients": [
    "4 banany, rozgniecione widelcem (im bardziej dojrzałe, tym lepsze)",
    "4 jajka",
    "½ szklanki masła migdałowego",
    "2 łyżki oleju kokosowego, roztopionego",
    "½ szklanki mąki kokosowej",
    "2 łyżeczki cynamonu",
    "½ łyżeczki gałki muszkatołowej",
    "1 łyżeczka proszku do pieczenia bezglutenowego",
    "1 łyżeczka sody oczyszczonej",
    "¼ łyżeczki soli himalajskiej lub innej wysokiej jakości"
  ].join("\n"),
  "path": "babeczki"
}
,


]

export default Babeczki;
